"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFactory = exports.each = exports.val = exports.Factory = exports.Derived = exports.Generator = exports.Pipeline = exports.Sync = exports.Async = void 0;

const Async = require("./async");

exports.Async = Async;

const Sync = require("./sync");

exports.Sync = Sync;

const Pipeline = require("./pipeline");

exports.Pipeline = Pipeline; // for now, for backwards compat

var sync_1 = require("./sync");

Object.defineProperty(exports, "Generator", {
  enumerable: true,
  get: function () {
    return sync_1.Generator;
  }
});
Object.defineProperty(exports, "Derived", {
  enumerable: true,
  get: function () {
    return sync_1.Derived;
  }
});
Object.defineProperty(exports, "Factory", {
  enumerable: true,
  get: function () {
    return sync_1.Factory;
  }
});
Object.defineProperty(exports, "val", {
  enumerable: true,
  get: function () {
    return sync_1.val;
  }
});
Object.defineProperty(exports, "each", {
  enumerable: true,
  get: function () {
    return sync_1.each;
  }
});
Object.defineProperty(exports, "makeFactory", {
  enumerable: true,
  get: function () {
    return sync_1.makeFactory;
  }
}); //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaUNBQWlDO0FBQ3hCLHNCQUFLO0FBRWQsK0JBQStCO0FBQ3RCLG9CQUFJO0FBRWIsdUNBQXVDO0FBQzlCLDRCQUFRO0FBSWpCLGdDQUFnQztBQUNoQywrQkFVZ0I7QUFSZCxpR0FBQSxTQUFTLE9BQUE7QUFDVCwrRkFBQSxPQUFPLE9BQUE7QUFDUCwrRkFBQSxPQUFPLE9BQUE7QUFHUCwyRkFBQSxHQUFHLE9BQUE7QUFDSCw0RkFBQSxJQUFJLE9BQUE7QUFDSixtR0FBQSxXQUFXLE9BQUEifQ==